import React from 'react'
import Link from 'gatsby-link'
import './header.css'

// -- Stateless Component
// const Header = () => (
//   <div className="Header">
//     <div className="HeaderGroup">
//         <Link to="/"><img width="30px" src={'images/logo-designcode.svg'} /></Link>
//         <Link to="/courses">Courses</Link>
//         <Link to="/downloads">Downloads</Link>
//         <Link to="/workshops">Workshops</Link>
//         <Link to="/buy"><button>Buy</button></Link>
//     </div>
//   </div>
// )


// -- Stateful Component
class Header extends React.Component {
  // Set up Constructor
  constructor(props) {
    super(props);

    this.state = {
      hasScrolled: false
    }
  }

  // Set up Listener
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = (event) => {
    const scrollTop = window.pageYOffset;
    // console.log('Offset: ' + scrollTop);

    if( scrollTop > 50 ) {
      // this.state.hasScrolled = true;
      this.setState({ hasScrolled: true });
    } else {
      // this.state.hasScrolled = false;
      this.setState({ hasScrolled: false });
    }
  }

  render() {
    return (
      <header className={ this.state.hasScrolled ? "Header HeaderScrolled" : "Header" }>
        <div className="HeaderGroup">
          <Link className="TextLogo" to="/">Gloria Ngo</Link>
          <Link to="/#portfolio">Portfolio</Link>
        </div>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js